import React from 'react';
import styled from 'styled-components';
import { Responsive } from 'semantic-ui-react';
import Swipe from './Swipe';

const Container = styled.div`
  background-color: #e4ff5f;
  padding: 10px;
  text-align: center;
`;

export default () => {
  return (
    <Container>
      <div className="container-box">
        <h2 className="title" style={{ marginTop: 40 }}>
          What is Popshop Live?
        </h2>
        <p className="description">
          Popshop Live is redefining the e-commerce space with a new
          livestreaming shopping app that enables influencers to talk about,
          showcase, and sell your products.
        </p>
        <Responsive minWidth={640}>
          <img
            width="100%"
            alt="mobile"
            src={require(`../assets/images/mobile.png`)}
          />
        </Responsive>
        <Responsive maxWidth={639}>
          <Swipe />
        </Responsive>
      </div>
    </Container>
  );
};
